import { styled } from '@mui/material/styles';

const StyledSetHeaderRow = styled('div')({
  display: 'flex',
  justifyContent: 'space-between'
})

const StyledAddSetButton = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  background: `${props => props.theme.palette.lightestGray}`,
  border: `1px solid ${props => props.theme.palette.lighterGray}`,
  opacity: '0.7',
  transition: 'opacity 175ms linear'
})

export { StyledSetHeaderRow, StyledAddSetButton };
